// extracted by mini-css-extract-plugin
module.exports = {"team":"Team_team__3ZLly","intro":"Team_intro__7unoc","team__images":"Team_team__images__3wEDA","team__headshots":"Team_team__headshots__vtAhj"};